<template>
  <div class="animated fadeIn load-inventory-page">
    <b-row>
      <b-col>
        <transition name="fade">
          <b-card
            border-variant="info"
            header-bg-variant="primary"
            header-text-variant="white"
            class="card-wrap"
          >
            <component-new-header
              title="Load Inventory"
              :hasSearch="false"
              :hasReload="false"
              :hasRadio="false"
              :hasCreate="false"
              :hasback="false"
            />

            <!-- Section 1: Warehouse & Item Selection -->
            <div class="section-block">
              <b-row class="align-items-center">
                <b-col cols="12" sm="12" md="4" class="field-col">
                  <label class="field-label">Warehouse</label>
                  <b-form-group class="mb-0">
                    <eb-select
                      type="text"
                      :options="stockOptions"
                      label="label"
                      placeholder="Select Warehouse"
                      @input="changeStockpoint"
                    ></eb-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="12" md="4" class="field-col">
                  <label class="field-label">Item</label>
                  <b-form-group class="mb-0">
                    <eb-select
                      type="text"
                      :options="itemList"
                      label="label"
                      placeholder="Select Item"
                      @input="changeItem"
                    ></eb-select>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="2" class="field-col">
                  <label class="field-label">Current Qty</label>
                  <b-form-group class="mb-0">
                    <b-input
                      type="text"
                      v-model="itemCount"
                      placeholder="Quantity"
                      disabled
                      class="qty-input"
                    ></b-input>
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="6" md="2" class="field-col btn-col">
                  <b-button
                    variant="primary"
                    :disabled="!itemId || itemId === ''"
                    @click="downloadTemplate"
                    class="action-btn w-100"
                  >
                    <b-icon icon="download" class="mr-1"></b-icon>
                    Download Template
                  </b-button>
                </b-col>
              </b-row>
            </div>

            <div class="section-divider"></div>

            <!-- Section 2: Quick Load -->
            <div class="section-block">
              <b-row class="align-items-center">
                <b-col cols="12" sm="12" md="10" class="field-col">
                  <label class="field-label">Quantity</label>
                  <b-form-group class="mb-0">
                    <c-input
                      :inputType="'text'"
                      inputId="Quantity"
                      v-model="quantityValue"
                      labelText="Quantity"
                    />
                  </b-form-group>
                </b-col>

                <b-col cols="12" sm="12" md="2" class="field-col btn-col">
                  <b-button
                    variant="success"
                    :disabled="
                      !(
                        quantityValue &&
                        itemId &&
                        stockPointId &&
                        quantityValue !== '0'
                      )
                    "
                    @click="quickLoadInventory"
                    class="action-btn w-100"
                  >
                    <b-icon icon="lightning-fill" class="mr-1"></b-icon>
                    Quick Load
                  </b-button>
                </b-col>
              </b-row>
            </div>

            <div class="section-divider"></div>

            <!-- Section 3: File Upload -->
            <div class="section-block">
              <b-row class="align-items-center">
                <b-col cols="12" sm="12" md="10" class="field-col">
                  <label class="field-label">Upload Template File</label>
                  <b-form-file
                    placeholder="Select a Template (.xls)"
                    @change="selectFile"
                    drop-placeholder="Drop file here..."
                    class="file-input"
                  ></b-form-file>
                </b-col>

                <b-col cols="12" sm="12" md="2" class="field-col btn-col">
                  <b-button
                    variant="primary"
                    :disabled="!itemId || itemId === ''"
                    @click="uploadFile"
                    class="action-btn w-100"
                  >
                    <b-icon icon="cloud-upload-fill" class="mr-1"></b-icon>
                    Load Inventory
                  </b-button>
                </b-col>
              </b-row>
            </div>

          </b-card>
        </transition>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import loader from "@/components/loader/nipigeloader.vue";
import ebSelect from "@/components/FormElements/Select";
import cInput from "@/components/Common/CustomInput";
import componentNewHeader from "@/components/componentNewHeader";

export default {
  name: "LoadInventory",
  components: {
    ebSelect,
    cInput,
    loader,
    componentNewHeader,
  },
  data: () => ({
    itemCount: "",
    itemId: "",
    providerId: "",
    stockPointId: "",
    selectedFile: null,
    quantityValue: "",
    loading: false,
  }),
  methods: {
    ...mapActions({
      GetStockpoints: "partner/fetchStockpointsByTenant",
      GetItems: "item/fetchItemsByCatalog",
      DownloadTemplate: "inventory/downloadInventoryTemplate",
      UploadFile: "inventory/uploadFileToStorage",
      LoadInventory: "inventory/loadInventory",
      LoadInventorySeed: "inventory/loadInventorySeed",
    }),
    changeStockpoint(data) {
      if (data !== null) {
        this.loading = true;
        this.providerId = data.providerId;
        this.stockPointId = data._id;
        let payload = { needInventory: true };
        if (this.userCategory === "MANUFACTURER") {
          payload.manufacturerId = this.$store.getters["auth/getUserID"];
        } else {
          payload.provider = data.providerId;
        }
        this.GetItems(payload)
          .then(() => (this.loading = false))
          .catch(() => (this.loading = false));
      }
    },
    changeItem(data) {
      this.itemId = data._id;
      if (data.quantity) {
        this.itemCount = data?.quantity[0]?.attributes?.Quantity || "";
      }
    },
    downloadTemplate() {
      this.loading = true;
      this.DownloadTemplate(this.itemId)
        .then((res) => {
          this.loading = false;
          const element = document.createElement("a");
          element.setAttribute(
            "href",
            window.URL.createObjectURL(new Blob([res]))
          );
          element.setAttribute("download", `${this.itemId}_template.xls`);
          element.style.display = "none";
          document.body.appendChild(element);
          element.click();
          document.body.removeChild(element);
        })
        .catch(() => (this.loading = false));
    },
    selectFile(event) {
      setTimeout(() => {
        this.selectedFile = event.target.files[0];
      }, 500);
    },
    async uploadFile() {
      let formdata = new FormData();
      formdata.append("file", this.selectedFile);
      formdata.append(
        "key",
        (
          Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
        ).toLowerCase()
      );
      formdata.append("isPublic", true);
      formdata.append("replaceExisting", true);
      formdata.append("basePath", "inventory");
      await this.UploadFile(formdata)
        .then((res) => {
          this.loadInventory(res.data.fileUrl);
        })
        .catch(() => {
          this.$swal({
            type: "error",
            text: "File Upload failed! please try again.",
          });
          this.loading = false;
        });
    },
    loadInventory(fileUrl) {
      let payload = {
        itemId: this.itemId,
        providerId: this.providerId,
        stockPointId: this.stockPointId,
        fileUrl: fileUrl,
      };
      this.LoadInventory(payload)
        .then(() => {
          this.loading = false;
          this.$swal({ type: "success", text: "Inventory Load Successfully!" });
        })
        .catch(() => (this.loading = false));
    },
    quickLoadInventory() {
      let payload = {
        itemId: this.itemId,
        stockPointId: this.stockPointId,
        quantity: Number(this.quantityValue),
      };
      this.LoadInventorySeed(payload)
        .then(() => {
          this.loading = false;
          this.$swal({ type: "success", text: "Inventory Loaded Successfully!" });
          this.quantityValue = null;
        })
        .catch(() => (this.loading = false));
    },
  },
  computed: {
    stockOptions() {
      let data = this.$store.getters["partner/GetAllStockPointList"];
      let userId = this.$store.getters["auth/getUserID"];
      if (data.length > 0) {
        return data.map((obj) => ({
          _id: obj._id,
          providerId: userId,
          label: obj.office?.officeName || "",
        }));
      }
      return [];
    },
    itemList() {
      let data = this.$store.getters["item/GetItemListByCatalog"];
      if (data.length > 0) {
        return data.map((obj) => ({
          _id: obj._id,
          label: obj.description_summary,
          quantity:
            obj?.variations?.filter(
              (volItem) => volItem._id == obj.variationId
            ) || [],
        }));
      }
      return [];
    },
    userCategory() {
      return JSON.parse(sessionStorage.getItem("userLogin"))["category"];
    },
  },
  async mounted() {
    await this.$store.dispatch("partner/fetchAllStockPointTenant");
  },
};
</script>

<style lang="sass" scoped>
.load-inventory-page
  padding: 0.5rem

.card-wrap
  min-height: 400px
  border-radius: 8px
  overflow: hidden

// Section blocks for visual grouping
.section-block
  padding: 1rem 0.5rem
  border-radius: 6px

.section-label
  font-size: 0.75rem
  font-weight: 700
  text-transform: uppercase
  letter-spacing: 0.08em
  color: #6c757d
  margin-bottom: 0.85rem
  padding-bottom: 0.4rem
  border-bottom: 1px dashed #dee2e6

.section-divider
  border-top: 1px solid #e9ecef
  margin: 0.25rem 0

// Consistent vertical spacing for all field columns
.field-col
  margin-bottom: 0.75rem

  @media (min-width: 768px)
    margin-bottom: 0

// Labels above inputs
.field-label
  display: block
  font-size: 0.8rem
  font-weight: 600
  color: #495057
  margin-bottom: 0.35rem

// Disabled quantity input visual treatment
.qty-input
  background-color: #f8f9fa !important
  color: #6c757d
  font-weight: 600
  text-align: center

// Buttons flush at bottom with inputs on desktop
.btn-col
  display: flex
  align-items: flex-end

  @media (max-width: 767px)
    align-items: stretch

.action-btn
  height: 38px
  font-size: 0.85rem
  font-weight: 600
  white-space: nowrap
  display: flex
  align-items: center
  justify-content: center
  gap: 0.3rem

  @media (max-width: 767px)
    width: 100% !important
    margin-top: 0.25rem

// File input consistent height
.file-input
  height: 38px

// Align b-form-group to remove extra bottom margin
.b-form-group
  margin-bottom: 0 !important
</style>